import { render, staticRenderFns } from "./AreaPlantadaVegetacaoNativa2022Soja.vue?vue&type=template&id=3bed7640&lang=pug"
import script from "./AreaPlantadaVegetacaoNativa2022Soja.vue?vue&type=script&lang=js"
export * from "./AreaPlantadaVegetacaoNativa2022Soja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports